function parseLineItems(valor) {
  if (typeof valor !== 'string') return [];
  return valor
    .split(/\r?\n/)
    .map((item) => item.trim())
    .filter(Boolean);
}

function normalizeLandingPage(landing = {}, empresa = {}) {
  const safeLanding = landing || {};
  const servicios = Array.isArray(safeLanding.servicios)
    ? safeLanding.servicios.filter(Boolean)
    : parseLineItems(safeLanding.servicios);
  const beneficios = Array.isArray(safeLanding.beneficios)
    ? safeLanding.beneficios.filter(Boolean)
    : parseLineItems(safeLanding.beneficios);
  const stats = Array.isArray(safeLanding.stats)
    ? safeLanding.stats.filter(Boolean)
    : parseLineItems(safeLanding.stats);
  const testimonials = Array.isArray(safeLanding.testimonials)
    ? safeLanding.testimonials.filter(Boolean)
    : parseLineItems(safeLanding.testimonials);
  const bloques = Array.isArray(safeLanding.bloques)
    ? safeLanding.bloques.map((bloque, index) => ({
        ...bloque,
        id: bloque?.id || `bloque-${index + 1}`,
        activo: bloque?.activo !== false,
        tipo: bloque?.tipo || 'texto',
        titulo: bloque?.titulo || '',
        contenido: bloque?.contenido || '',
        altura: bloque?.altura || 280,
        orden: index,
      }))
    : [];

  return {
    ...safeLanding,
    titulo: safeLanding.titulo || 'Gestión digital para tu negocio',
    slogan: safeLanding.slogan || 'Más control, menos caos',
    descripcion: safeLanding.descripcion || 'Trix centraliza clientes, ventas, tareas, facturación y operaciones en un único espacio.',
    ctaTexto: safeLanding.ctaTexto || 'Solicitar demo',
    ctaLink: safeLanding.ctaLink || '/login',
    email: safeLanding.email || '',
    telefono: safeLanding.telefono || '',
    whatsapp: safeLanding.whatsapp || '',
    heroBadge: safeLanding.heroBadge || 'Gestión conectada para PYMEs',
    layoutVariant: safeLanding.layoutVariant || 'clasico',
    colorPrimario: safeLanding.colorPrimario || '#4f46e5',
    colorSecundario: safeLanding.colorSecundario || '#0ea5e9',
    showStats: safeLanding.showStats !== false,
    showTestimonials: safeLanding.showTestimonials !== false,
    servicios,
    beneficios,
    stats,
    testimonials,
    bloques,
    htmlLibre: safeLanding.htmlLibre || '',
    logo: safeLanding.logo || empresa?.logo || '',
    heroImage: safeLanding.heroImage || '',
  };
}

function getLandingPreviewData(landing = {}, empresa = {}) {
  const normalized = normalizeLandingPage(landing, empresa);
  return {
    ...normalized,
    empresaNombre: empresa?.nombre || 'Empresa',
  };
}

function reordenarBloquesLanding(bloques = [], fromIndex, toIndex) {
  if (!Array.isArray(bloques)) return [];
  if (fromIndex < 0 || toIndex < 0 || fromIndex >= bloques.length || toIndex >= bloques.length) {
    return bloques;
  }

  const copia = [...bloques];
  const [item] = copia.splice(fromIndex, 1);
  copia.splice(toIndex, 0, item);
  return copia.map((bloque, index) => ({ ...bloque, orden: index }));
}

export { parseLineItems, normalizeLandingPage, getLandingPreviewData, reordenarBloquesLanding };
export default { parseLineItems, normalizeLandingPage, getLandingPreviewData, reordenarBloquesLanding };
